import './style.scss'
import utility from "src/utils/utility"
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import ApiContext from 'src/provider/API/call-service';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import VisibilityContext from 'src/provider/state-manager/visibilityProvider';
import { AppSpan, AppText, Button, Circle, CustomContainer, FlexColumn, FlexRow, GridContainer, PageWrapper } from "src/style"
import { IoIosArrowBack } from "react-icons/io";
import ProfileBgImg from 'src/assets/img/profile-bg-img.svg'
import UserPics from 'src/assets/img/profile-pics.jpg'
import { PasswordChange } from 'src/popup';

const UserProfile = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {decisionBox} = useContext(VisibilityContext)
    const {info: {selectedUser, profileTypeAccess}} = useContext(AppInfoContext)
    const [user, setUser] = useState<any>(null)
    const [accessType, setAccessType] = useState(profileTypeAccess)
    const [view, setView] = useState('')

    useEffect(() => {
        if (selectedUser) setUser(selectedUser)
    }, [selectedUser])

    useEffect(() => {
        if (profileTypeAccess) setAccessType(profileTypeAccess)
    }, [profileTypeAccess])

    function handleDeactivation () {
        decisionBox.show(
            `Are you sure you want to deactivate user?`,
            null,
            decisionBox.hide,
            `Yes, Deactivate`,
            'No'
        )
    }

    function handlePasswordReset () {
        decisionBox.show(
            `Are you sure you want to reset password?`,
            () => setView('change-password'),
            decisionBox.hide,
            `Yes, Reset`,
            'No'
        )
    }

    return (
        <>
            <PageWrapper>
                <CustomContainer topMargin='2.5'>
                    <FlexRow 
                        justifyContent='flex-start' gap='1'
                        width='auto' sizeUnit=''
                        onClick={() => navigate(-1)}
                    >
                        <AppSpan textSize='2' cursor='pointer' >
                            <IoIosArrowBack />
                        </AppSpan>
                        <AppText 
                            textSize='3' fontWeight="500" color='#101828' cursor='pointer'
                        >
                            User details
                        </AppText>
                    </FlexRow>
                    <CustomContainer 
                        maxHeight='17.6' radius='0.46'
                        height='17.6' topMargin='2'
                    >
                        <img 
                            src={ProfileBgImg} 
                            className='img-covered' 
                            style={{width: '100%', objectFit: 'cover'}} 
                        />
                    </CustomContainer>
                    <FlexRow 
                        justifyContent='space-between' topMargin='-6.5' 
                        alignItems='stretch' bottomPadding='3'
                        gap='1.5' leftPadding='2' rightPadding='2'
                        className='profile-content-wrapper'
                    >
                        <FlexColumn 
                            bgColor='#ffffff' width='20.9' minHeight='22.3' 
                            radius='0.8' padding='2'
                            shadow='0px 4px 20.7px 0px #0000000D'
                            className='profile-pics-container'
                        >
                            <Circle 
                                size='9.2' bgColor='#0A756F' //bgColor='#DBDBDB' 
                                bottomMargin='1.5'
                                style={{overflow: 'hidden'}}
                            >
                                {/* <img src={user?.profilePictureUrl || UserPics} className='img-covered' /> */}
                                <AppText 
                                    textSize='2.7' color='#ffffff' 
                                    fontWeight='600' cursor='pointer'
                                >
                                    {user?.firstName?.[0]}{user?.lastName?.[0]}
                                </AppText>
                            </Circle>
                            <GridContainer>
                                <AppSpan 
                                    color='#58595B' fontWeight="600"
                                >
                                    {user?.firstName} {user?.lastName}
                                </AppSpan>
                                <AppText color='#A098AE' align='center'>{user?.email}</AppText>
                            </GridContainer>
                        </FlexColumn>
                        <FlexColumn 
                            className='profile-details-container'
                            bgColor='#ffffff' minHeight='16.7'
                            shadow='0px 4px 20.7px 0px #0000000D'
                            radius='0.8' padding='2.5' justifyContent='space-between'
                        >
                            <FlexRow 
                                justifyContent='flex-start' alignItems='flex-start'
                                gap='5' wrap='wrap'
                            >
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText color='#333542' fontWeight="600">Full name</AppText>
                                    <AppSpan>{user?.firstName} {user?.lastName}</AppSpan>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText color='#333542' fontWeight="600">Username</AppText>
                                    <AppSpan>{user?.userName}</AppSpan>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText color='#333542' fontWeight="600">Email</AppText>
                                    <AppSpan>{user?.email}</AppSpan>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText color='#333542' fontWeight="600">Phone number</AppText>
                                    <AppSpan>{user?.phoneNumber}</AppSpan>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText color='#333542' fontWeight="600">Status</AppText>
                                    <GridContainer 
                                        width='6.5' height='2.2' radius='1.6' 
                                        bgColor={user?.status === 'Active' ? '#ECFDF3' : '#FFEBEA'}
                                    >
                                        <AppSpan 
                                            textSize='1.2' fontWeight="500" 
                                            color={user?.status === 'Active' ? '#027A48' : '#D30202'}
                                        >
                                            {user?.status}
                                        </AppSpan>
                                    </GridContainer>
                                </CustomContainer>
                            </FlexRow>
                            <FlexRow justifyContent='flex-end' gap='1.5' wrap='wrap' topMargin='2'>
                                {/* { accessType === 'report' && */
                                    <Button
                                        width='14.1' bgColor='#E7F6F5'
                                        titleSize='1.4' fontWeight="500"
                                        height='4' radius='0.8' color='#0D968F'
                                        bottomMargin='1' hoverColor='#0D968F'
                                        hoverBgColor='#fff' hoverBorderColor='#0D968F'
                                        onClick={handleDeactivation}
                                    >
                                        Deactivate user
                                    </Button>
                                }
                                {/* { accessType === 'user' && */
                                    <Button
                                        width='13.9'
                                        titleSize='1.4' fontWeight="500"
                                        height='4' radius='0.8'
                                        bottomMargin='1' hoverColor='#0D968F'
                                        hoverBgColor='#fff' borderColor='#0D968F'
                                        onClick={handlePasswordReset}
                                    >
                                        Reset Password
                                    </Button>
                                }
                            </FlexRow>
                        </FlexColumn>
                    </FlexRow>
                </CustomContainer>
            </PageWrapper>
            { view === 'change-password' &&
                <PasswordChange
                    close={() => setView('')} 
                />
            }
        </>
    )
}

export default utility.routeData('users/user-profile', 'User Profile', <UserProfile/>)